// src/lib/idempotency.ts

const IDEMPOTENCY_HEADER = "Idempotency-Key";

function randomHex(bytes = 16): string {
  const arr = new Uint8Array(bytes);
  // Browser crypto
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(arr);
  } else {
    // Very rare fallback (SSR/tests)
    for (let i = 0; i < bytes; i++) {
      arr[i] = Math.floor(Math.random() * 256);
    }
  }

  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function generateIdempotencyKey(scope = "web"): string {
  const ts = Date.now().toString(36);
  const rnd = randomHex(8);
  return `${scope}_${ts}_${rnd}`;
}

/**
 * Ensure an Idempotency-Key header is present.
 * - Respects any existing header or explicit key.
 * - Returns merged headers + the key used.
 */
export function ensureIdempotencyHeader(
  headers: HeadersInit = {},
  explicitKey?: string
): { headers: HeadersInit; key: string } {
  const out: Record<string, string> = {};

  if (headers instanceof Headers) {
    headers.forEach((v, k) => {
      out[k] = v;
    });
  } else if (Array.isArray(headers)) {
    for (const [k, v] of headers) {
      out[k] = String(v);
    }
  } else {
    Object.assign(out, headers);
  }

  const existing =
    explicitKey ||
    out["Idempotency-Key"] ||
    out["idempotency-key"] ||
    out["idempotency_Key"];

  const key = existing || generateIdempotencyKey();

  out[IDEMPOTENCY_HEADER] = key;

  return { headers: out, key };
}